import { render } from "./AppLogo.vue?vue&type=template&id=67dd1ed6"
const script = {}

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__